export default function TikTokIcon({ className = "", strokeWidth = 4 }: { className?: string; strokeWidth?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="800"
      height="800"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      viewBox="0 0 64 64"
      className={className}
    >
      <path
        strokeLinecap="round"
        d="M52.46 26.64c-1.15.25-4.74.65-9.7-2.41a.5.5 0 00-.77.42v13.33c0 2.68.15 20.4-17.16 18.42 0 0-13.68-1-13.68-16.33 0 0 .19-13.8 16.42-15a.51.51 0 01.55.5v7.03a.48.48 0 01-.42.49c-1.9.27-9.54 1.8-8.69 8.77a7.19 7.19 0 007.37 6.3s7 .78 7.32-9V7.94a.51.51 0 01.5-.5h6.88a.5.5 0 01.49.41c.36 2 2.42 9.82 10.8 10.31a.5.5 0 01.48.49v7.51a.48.48 0 01-.39.48z"
      ></path>
    </svg>
  );
}
